<script lang="ts">
	// Store for wiki categories and articles
	const wikiCategories = [
		{
			name: 'Agriculture',
			articles: ['Agroforestry', 'Permaculture', 'Food Forests', 'Companion Planting']
		},
		{
			name: 'Building',
			articles: [
				'Cobb Building',
				'Natural Building',
				'Earthships',
				'Hempcrete Building',
				'Living Roofs'
			]
		},
		{
			name: 'Economics',
			articles: [
				'ReFi',
				'Regenerative Economics',
				'Local Currencies',
				'Gift Economy',
				'Cryptocurrencies'
			]
		},
		{
			name: 'Ecology',
			articles: ['Bioregionalism', 'Ecosystem Restoration', 'Native Species']
		},
		{
			name: 'Community Governance',
			articles: [
				'Bioregional Governance',
				'Community Land Trusts',
				'Restorative Justice',
				'Indigenous Leadership',
				'Federated Cooperatives',
				'Participatory Finance',
				'Transformative Justice'
			]
		}
	];

	let isWikiNavOpen = false;

	// Toggle wiki navigation on mobile
	function toggleWikiNav() {
		isWikiNavOpen = !isWikiNavOpen;
	}
</script>

<div class="flex min-h-screen bg-cosmicPurple900 3xl:pl-24">
	<!-- Wiki Navigation Sidebar -->
	<aside
		class="hidden lg:block w-64 bg-cosmicPurple800 border-r border-cosmicMagenta400 p-4 overflow-y-auto"
	>
		<h2 class="text-2xl font-exo-2 font-bold text-gradientBlueMid mb-6 text-left ml-3">
			Wiki Topics
		</h2>

		{#each wikiCategories as category}
			<div class="mb-6 text-left ml-3">
				<h3 class="text-lg font-bold text-gradientBlue mb-2">{category.name}</h3>
				<ul class="space-y-2">
					{#each category.articles as article}
						<li>
							<a
								href="/learn/wiki/{article.toLowerCase().replace(/\s+/g, '-')}"
								class="text-gray-200 hover:text-bloomBlueLightActive"
							>
								{article}
							</a>
						</li>
					{/each}
				</ul>
			</div>
		{/each}
	</aside>

	<!-- Mobile Wiki Nav Toggle -->
	<button
		class="lg:hidden fixed top-20 right-4 z-50 bg-cosmicPurple800 p-2 rounded-full border border-cosmicMagenta400 flex items-center gap-2"
		on:click={toggleWikiNav}
	>
		<svg class="w-6 h-6 text-gray-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
			<path
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="2"
				d="M4 6h16M4 12h16m-7 6h7"
			/>
		</svg>
		<span class="text-gray-200">Wiki Navigation</span>
	</button>

	<!-- Mobile Wiki Navigation -->
	{#if isWikiNavOpen}
		<div class="md:hidden fixed inset-0 z-40 bg-cosmicPurple900 bg-opacity-90">
			<div class="fixed inset-y-0 right-0 w-64 bg-cosmicPurple800 p-4 overflow-y-auto">
				<button class="absolute top-4 right-4" on:click={toggleWikiNav}>
					<span class="sr-only">Close menu</span>
					<svg class="w-6 h-6 text-gray-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="2"
							d="M6 18L18 6M6 6l12 12"
						/>
					</svg>
				</button>

				<!-- Same content as desktop sidebar -->
				<h2 class="text-2xl font-exo-2 font-bold text-gradientBlueMid mb-6 mt-8">Wiki Topics</h2>
				{#each wikiCategories as category}
					<div class="mb-6">
						<h3 class="text-lg font-bold text-gradientBlue mb-2">{category.name}</h3>
						<ul class="space-y-2">
							{#each category.articles as article}
								<li>
									<a
										href="/learn/wiki/{article.toLowerCase().replace(/\s+/g, '-')}"
										class="text-gray-200 hover:text-bloomBlueLightActive"
										on:click={toggleWikiNav}
									>
										{article}
									</a>
								</li>
							{/each}
						</ul>
					</div>
				{/each}
			</div>
		</div>
	{/if}

	<!-- Main Content -->
	<main class="flex-1 p-6 md:p-10 text-left">
		<slot />
	</main>
</div>
